import { writable, get } from "svelte/store";
export const plansDataStore = writable(null);
export function setPlansData(prices) {
    const data = {};
    for (let idx = 0; idx < prices.length; idx++) {
        const price = prices[idx];
        data[price.lookup_key] = price;
    }
    plansDataStore.set(data);
    console.log("plan data ============ ", data);
}
export function getPlansData() {
    return get(plansDataStore);
}
/**
 * Get plan base price
 * @param type
 * @param tier
 * @param recurring
 * @returns
 */
export function getPlanBasePrice(type, tier, recurring) {
    const plans = getPlansData();
    if (!plans)
        return;
    const lookup_key = [type, tier, recurring].join("_");
    return plans[lookup_key];
}
/**
 * Get per-seat price
 * Only organization have per seat price.
 * @param tier
 * @param recurring
 */
export function getPlanPerSeatPrice(tier, recurring) {
    const plans = getPlansData();
    if (!plans)
        return;
    const lookup_key = ["organization", tier, "perseat", recurring].join("_");
    return plans[lookup_key];
}
function formatCost(value) {
    return value / 100;
}
export function getPlanBaseCost(type, tier, recurring) {
    const price = getPlanBasePrice(type, tier, recurring);
    return price ? formatCost(price.unit_amount) : null;
}
export function getPlanPerSeatCost(tier, recurring) {
    const price = getPlanPerSeatPrice(tier, recurring);
    return price ? formatCost(price.unit_amount) : null;
}
const standardFeatures = [
    {
        item: "Features Include text 1.",
        enable: true
    },
    {
        item: "Features Included text 2. Two line text.",
        enable: true
    },
    {
        item: "Features Include text 3",
        enable: false
    },
];
const businessFeatures = [
    {
        item: "Features Include text 1.",
        enable: true
    },
    {
        item: "Features Included text 2. Two line text.",
        enable: true
    },
    {
        item: "Features Include text 3",
        enable: true
    },
];
const professionalFeatures = [
    {
        item: "Features Include text 1.",
        enable: true
    },
    {
        item: "Features Included text 2. Two line text.",
        enable: true
    },
    {
        item: "Features Include text 3",
        enable: true
    },
];
export const plansDescription = [
    {
        title: "Standard",
        value: "standard",
        features: standardFeatures,
        isRecommended: false
    },
    {
        title: "Business",
        value: "business",
        features: businessFeatures,
        isRecommended: true
    },
    {
        title: "Professional",
        value: "professional",
        features: professionalFeatures,
        isRecommended: false
    },
];
